import { render, staticRenderFns } from "./MembersStatList.vue?vue&type=template&id=e519dc38&"
import script from "./MembersStatList.vue?vue&type=script&lang=js&"
export * from "./MembersStatList.vue?vue&type=script&lang=js&"
import style0 from "./MembersStatList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports